/** Colours of the plays-per-week segments: 1 play, 2 plays, 3 plays … */
export const PLAYS_COLORS = ['#065A8E', '#0A78B8', '#8ED3DD', '#3BB8C9', '#B9E3EA'];

/** The week in progress is drawn in U red everywhere (design note). */
export const LIVE_COLOR = '#E2001A';
